import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from './components/header/header.component';
import {UsernameIconComponent} from './components/username-icon/username-icon.component';
import {UsernameMenuComponent} from './components/username-menu/username-menu.component';
import {MatButtonModule} from "@angular/material/button";
import {MatMenuModule} from "@angular/material/menu";
import {MatIconModule} from "@angular/material/icon";
import {HttpClientModule} from "@angular/common/http";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import { SubmitButtonComponent } from './components/submit-button/submit-button.component';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {RouterModule} from "@angular/router";
import { DialogConfirmComponent } from './components/dialog-confirm/dialog-confirm.component';
import {MatDialogModule} from "@angular/material/dialog";
import { DialogInputComponent } from './components/dialog-input/dialog-input.component';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { FullscreenLoaderComponent } from './components/fullscreen-loader/fullscreen-loader.component';
import { DialogAlertComponent } from './components/dialog-alert/dialog-alert.component';
import { DropZoneDirective } from './directives/drop-zone.directive';
import { FileUploadBlockComponent } from './components/file-upload-block/file-upload-block.component';
import { IconPickerComponent } from './components/icon-picker/icon-picker.component';
import { DialogInputIconComponent } from './components/dialog-input-icon/dialog-input-icon.component';
import { MsalModule } from "@azure/msal-angular";
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [
    HeaderComponent,
    UsernameIconComponent,
    UsernameMenuComponent,
    SubmitButtonComponent,
    DialogConfirmComponent,
    DialogInputComponent,
    FullscreenLoaderComponent,
    DialogAlertComponent,
    DropZoneDirective,
    FileUploadBlockComponent,
    IconPickerComponent,
    DialogInputIconComponent,
  ],
    exports: [
        HeaderComponent,
        SubmitButtonComponent,
        UsernameIconComponent,
        FullscreenLoaderComponent,
        DropZoneDirective,
        FileUploadBlockComponent
    ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatSnackBarModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    RouterModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MsalModule.forRoot({
      auth: {
        clientId: environment.oneDrive.appId
      }
    })
  ]
})
export class SharedModule {
}
